export interface KakaoAuthorizeUrlOptions {
  prompt?: 'none' | 'login' | 'consent';
  redirectUri?: string;
  extraScopes?: string[];
}

const DEFAULT_KAKAO_SCOPES = ['account_email'];
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const uniqueScopes = (scopes: string[]): string[] => {
  return Array.from(new Set(scopes.map((scope) => scope.trim()).filter(Boolean)));
};

export const buildKakaoAuthorizeUrl = (options: KakaoAuthorizeUrlOptions = {}): string => {
  const clientId = process.env.REACT_APP_KAKAO_CLIENT_ID || '';
  const redirectUri = options.redirectUri || `${window.location.origin}/auth/kakao/callback`;
  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: 'code',
  });

  const scopes = uniqueScopes([...DEFAULT_KAKAO_SCOPES, ...(options.extraScopes || [])]);
  if (scopes.length > 0) {
    params.set('scope', scopes.join(','));
  }

  if (options.prompt) {
    params.set('prompt', options.prompt);
  }

  return `https://kauth.kakao.com/oauth/authorize?${params.toString()}`;
};

export const isProvisionalEmail = (email?: string | null): boolean => {
  const normalized = (email || '').trim().toLowerCase();

  if (!normalized) {
    return true;
  }

  if (!EMAIL_REGEX.test(normalized)) {
    return true;
  }

  const domain = normalized.split('@')[1] || '';
  if (domain === 'temp.com' || domain.endsWith('.local')) {
    return true;
  }

  if (normalized.includes('noemail') || normalized.includes('no-email')) {
    return true;
  }

  return false;
};
